import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "kb_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const keyOf = (p, size, color) => `${p.id || p.product_id}__${size}__${color || ""}`;

  const add = (product, size, color, qty = 1) => {
    const k = keyOf(product, size, color);
    setItems(prev => {
      const found = prev.find(i => i._key === k);
      if (found) {
        return prev.map(i => i._key === k ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        _key: k,
        product_id: product.id,
        name: product.name,
        price: product.price,
        image: (product.images && product.images[0]) || "",
        size, color, quantity: qty,
      }];
    });
  };

  const updateQty = (key, qty) => {
    if (qty <= 0) { remove(key); return; }
    setItems(prev => prev.map(i => i._key === key ? { ...i, quantity: qty } : i));
  };

  const remove = (key) => setItems(prev => prev.filter(i => i._key !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, updateQty, remove, clear, count, subtotal }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
